import React from 'react';

import Hero from './Hero';


function ContactPage () {
    return (
        <>
          <Hero />
        </>
    );
}

export default ContactPage;